var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page',[_c('div',{staticClass:"card d-flex flex-row"},[_c('div',{staticClass:"d-flex flex-column"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }